const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

function getServiceWorkerUrl() {
  // Bust browser SW script cache on every app boot
  return `${process.env.PUBLIC_URL || ""}/pwa-sw.js?v=${Date.now()}`;
}

/** Drop Cache Storage + force SW update so each load uses the latest build. */
export async function clearAppCaches() {
  try {
    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    }
  } catch {
    /* ignore */
  }
}

export function register() {
  if (!("serviceWorker" in navigator)) return;

  const start = async () => {
    await clearAppCaches();

    const swUrl = getServiceWorkerUrl();
    if (isLocalhost || process.env.NODE_ENV === "development") {
      checkValidServiceWorker(swUrl);
      return;
    }

    try {
      const registration = await navigator.serviceWorker.register(swUrl, {
        updateViaCache: "none",
      });
      registration.update().catch(() => undefined);
      // Prefer the waiting worker immediately (new deploy)
      if (registration.waiting) {
        registration.waiting.postMessage({ type: "SKIP_WAITING" });
      }
      registration.addEventListener("updatefound", () => {
        const worker = registration.installing;
        if (!worker) return;
        worker.addEventListener("statechange", () => {
          if (worker.state === "installed" && navigator.serviceWorker.controller) {
            worker.postMessage({ type: "SKIP_WAITING" });
          }
        });
      });
    } catch (error) {
      console.error("Error during service worker registration:", error);
    }
  };

  if (document.readyState === "complete") {
    void start();
    return;
  }
  window.addEventListener("load", () => {
    void start();
  });
}

function checkValidServiceWorker(swUrl: string) {
  fetch(swUrl, {
    headers: { "Service-Worker": "script" },
    cache: "no-store",
  })
    .then((response) => {
      const contentType = response.headers.get("content-type");
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf("javascript") === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister();
        });
      } else {
        navigator.serviceWorker
          .register(swUrl, { updateViaCache: "none" })
          .catch(() => undefined);
      }
    })
    .catch(() => {
      navigator.serviceWorker
        .register(swUrl, { updateViaCache: "none" })
        .catch(() => undefined);
    });
}
